/**
 * @fileoverview Agent definition for critique-voice-emotion.
 *
 * This agent analyzes prose for POV consistency, emotional resonance,
 * dialogue authenticity, vocabulary register, and tone stability.
 *
 * @category narrative.prose.critique
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'critique-voice-emotion',
  kind: 'primitive',
  name: 'Voice & Emotion Critic',
  description: 'Analyzes prose for POV consistency, emotional resonance, dialogue authenticity, vocabulary register, and tone stability.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-08',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.critique',
    usedBy: [
      'use-critique-voice-emotion.ts',
    ],
    usedInComposites: [
      'critique-committee-v2',
    ],
    relatedAgents: [
      'critique-prose-flow',
      'critique-sensory-atmosphere',
    ],
  },
};
